import type { FC } from 'react';

const ExampleResearchOutput: FC = () => (
  <div className="rounded-lg border border-white/[0.08] overflow-hidden shadow-lg shadow-black/15 font-mono text-[13px]" style={{ background: '#0f1923' }}>
    {/* Header bar */}
    <div className="flex items-center justify-between px-5 py-2.5 border-b border-white/[0.06]" style={{ background: '#0c1520' }}>
      <div className="flex items-center gap-3">
        <span className="text-[10px] text-gray-500 uppercase tracking-wider">Strategy Report</span>
        <span className="text-gray-700">|</span>
        <span className="text-[10px] text-gray-400">BTC Mean Reversion</span>
      </div>
      <div className="flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-400/70" />
        <span className="text-[9px] text-emerald-400/80">Validated</span>
      </div>
    </div>

    {/* Metrics grid */}
    <div className="grid grid-cols-2 md:grid-cols-4 gap-px" style={{ background: 'rgba(255,255,255,0.04)' }}>
      {[
        { label: 'Sharpe Ratio', value: '1.9', color: 'text-emerald-400' },
        { label: 'Walk-Forward Efficiency', value: '0.74', color: 'text-white' },
        { label: 'Cluster Stability', value: '82', color: 'text-white' },
        { label: 'Regime Coverage', value: '4 regimes', color: 'text-white' },
      ].map((m) => (
        <div key={m.label} className="px-5 py-5" style={{ background: '#0f1923' }}>
          <p className="text-[9px] text-gray-500 uppercase tracking-wider mb-2">{m.label}</p>
          <p className={`text-[22px] font-bold ${m.color} tracking-tight`}>{m.value}</p>
        </div>
      ))}
    </div>

    {/* Pipeline stages */}
    <div className="px-5 py-4 border-t border-white/[0.06]">
      <p className="text-[9px] text-gray-500 uppercase tracking-wider mb-3">Validation Pipeline</p>
      <div className="flex items-center gap-2 flex-wrap">
        {[
          { stage: 'Baseline', status: 'pass' },
          { stage: 'Multi-Asset', status: 'pass' },
          { stage: 'Walk-Forward', status: 'pass' },
          { stage: 'Stability', status: 'pass' },
          { stage: 'Adaptive Flow', status: 'active' },
        ].map((s, i) => (
          <div key={s.stage} className="flex items-center gap-2">
            <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded text-[10px] ${s.status === 'pass'
              ? 'bg-emerald-400/10 text-emerald-400/80'
              : 'bg-[#9d4edd]/10 text-[#9d4edd]/80'
              }`}>
              <span className={`w-1 h-1 rounded-full ${s.status === 'pass' ? 'bg-emerald-400/70' : 'bg-[#9d4edd]/70'
                }`} />
              {s.stage}
            </div>
            {i < 4 && <span className="text-gray-700 text-[10px]">&rarr;</span>}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ExampleResearchOutput;
